import { render, staticRenderFns } from "./ConnertMenuStat.vue?vue&type=template&id=47ca7466&"
import script from "./ConnertMenuStat.vue?vue&type=script&lang=js&"
export * from "./ConnertMenuStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports